module.exports = __webpack_public_path__ + "img/verrassing-automaat.f311b452.jpg";